import { render, staticRenderFns } from "./TwelveLaboursFooter.vue?vue&type=template&id=209901b4&scoped=true&"
import script from "./TwelveLaboursFooter.vue?vue&type=script&lang=js&"
export * from "./TwelveLaboursFooter.vue?vue&type=script&lang=js&"
import style0 from "./TwelveLaboursFooter.vue?vue&type=style&index=0&id=209901b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209901b4",
  null
  
)

export default component.exports